/**
 *  Video popup modal - click open and close events for Vimeo and Wistia
 */
import {Utilities} from "./utilities";
const utilities = new Utilities();

export class Video {
    constructor() {
        this.thumbnails = document.querySelectorAll('.vimeo-thumbnail, .wistia-thumbnail');
        this.iframes = document.querySelectorAll('.vimeo-iframe');
        this.closeButtons = document.querySelectorAll('.close-video');
    }

    init() {
        this.thumbnailOnClickOrTouch();
        this.iframeOnClick();
        this.clickClose();
    }

    thumbnailOnClickOrTouch() {
        this.thumbnails.forEach((thumbnail) => {
            thumbnail.addEventListener('click', e => {
                e.preventDefault();
                this.triggerPopup(e);
            });

            let touchY = null;
            thumbnail.addEventListener('touchstart', event => {
                touchY = event.touches[0].clientY;
            });
            thumbnail.addEventListener('touchend', event => {
                event.preventDefault();
                let newTouchY = event.changedTouches[0].clientY;
                if (Math.abs(newTouchY - touchY) > 5) {
                    //User is swiping
                } else {
                    //User is clicking
                    this.triggerPopup(event);
                }
                touchY = null;
            });
        });
    }

    triggerPopup(e) {
        let thumbnailContainer = e.target.closest('.vimeo-thumbnail') || e.target.closest('.wistia-thumbnail');
        const iframeId = thumbnailContainer.getAttribute('data-iframe');
        const iframeContainer = document.getElementById(iframeId);

        if (iframeContainer) {
            //Show iframe container
            utilities.fadeIn(iframeContainer, 'flex');
            //Set iframe size
            this.setIframeSize(iframeContainer.querySelector('.cf-video-holder'));
            //Play video
            this.playVideo(iframeContainer);
        }
    }

    clickClose() {
        this.closeButtons.forEach((closeButton) => {
            closeButton.addEventListener('click', (e) => {
                const thisIframeContainer = closeButton.closest('.vimeo-iframe');
                utilities.fadeOut(thisIframeContainer);
                this.stopVideo(thisIframeContainer);
            });
        });
    }

    iframeOnClick() {
        this.iframes.forEach((iframe) => {
            iframe.addEventListener('click', e => {
                if (e.target.classList.contains('vimeo-iframe')) {
                    utilities.fadeOut(e.target);
                    e.target.querySelector('.close-video').style.display = 'none';
                    this.stopVideo(iframe);
                }
            });
        });
    }

    setIframeSize(iframeEl) {
        const width = window.innerWidth;
    const height = window.innerHeight;
    let iframeWidth, iframeHeight;
    const ratio = 0.5625;
    if (height / width > ratio) {
        // Tall window
        iframeWidth = width * 0.9;
        iframeHeight = iframeWidth * ratio;
    } else {
        // Wide window
        iframeHeight = height * 0.9;
        iframeWidth = iframeHeight / ratio;
    }
    iframeEl.style.width = `${iframeWidth}px`;
    iframeEl.style.height = `${iframeHeight}px`;

        //Adjust close button position
        const iframeParent = iframeEl.closest('.vimeo-iframe');
        const closeButton = iframeParent.querySelector('.close-video');
        const distanceX = (width - iframeWidth) / 2 + 20;
        const distanceY = (height - iframeHeight) / 2 + 20;
        closeButton.style.right = `${distanceX}px`;
        closeButton.style.top = `${distanceY}px`;
        setTimeout(() => {
            closeButton.style.display = 'block';
        }, 1000);
    }

    playVideo(el) {
        let iframe = el.querySelector('iframe');
        const wistiaEmbed = el.querySelector('.wistia_embed');
        if (iframe && iframe.hasAttribute('data-src')) {
            iframe.src = iframe.getAttribute('data-src');
        }
        if (wistiaEmbed) {
            const videoId = wistiaEmbed.classList[1].split('_')[2];
            window._wq = window._wq || [];
            _wq.push({ id: videoId, onReady: function(video) {
                video.play();
            }});
        }
    }

    stopVideo(el) {
        let iframe = el.querySelector('iframe');
        const wistiaEmbed = el.querySelector('.wistia_embed');
        if (iframe) {
            iframe.src = '';
        }
        if (wistiaEmbed) {
            const videoId = wistiaEmbed.classList[1].split('_')[2];
            window._wq = window._wq || [];
            _wq.push({ id: videoId, onReady: function(video) {
                video.pause();
            }});
        }
    }
}